export default __webpack_public_path__ + "static/media/Botrel.5e41fbfb.png";